// 引入api请求方法
import { getRouteListByBid } from '@/api/routeInfo';
import {
  pageSettlementByOil,
  payStatusByOil,
  getChildList,
  rechargeRecordsByChannel,
} from '@/api/freight';
import { oneTicket } from '@/utils/selectCom';

const storeModuleName = 'payOilModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'input-multiple',
      param: 'waybillNos',
      value: '',
      valueType: 'string',
      label: '运单号',
      multiple: true,
      placeholder: '请输入',
      append: '多运单',
      multipleLabel: '运单号',
      multiplePlaceholder:
        '最多可填写50个运单号，需输入完整运单号，运单号中间不能有空格，运单号不换行时请用英文逗号隔开，换行时请每行1个运单号。',
      clearable: true,
    },

    {
      style: 'input-multiple',
      param: 'driverMobiles',
      value: '',
      valueType: 'string',
      label: '司机',
      multiple: true,
      placeholder: '姓名/手机号',
      append: '多司机',
      multipleLabel: '姓名/手机号',
      multiplePlaceholder:
        '最多可填写50个姓名/手机号，需输入完整姓名/手机号，姓名/手机号中间不能有空格，姓名/手机号不换行时请用英文逗号隔开，换行时请每行1个姓名/手机号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'vehicleNos',
      value: '',
      valueType: 'string',
      label: '车牌号',
      multiple: true,
      placeholder: '请输入',
      append: '多车牌号',
      multipleLabel: '车牌号',
      multiplePlaceholder:
        '最多可填写50个车牌号，需输入完整车牌号，车牌号中间不能有空格，车牌号不换行时请用英文逗号隔开，换行时请每行1个车牌号。',
      clearable: true,
    },
    {
      style: 'autocomplete',
      param: 'orderName',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'date-picker',
      param: 'insertTime',
      value: [],
      valueType: 'date',
      label: '申请时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['insertStartTime', 'insertEndTime'],
    },
    {
      style: 'select',
      param: 'oneTicket',
      value: 'OFF',
      valueType: 'string',
      state: 'oneTicket',
      label: '是否一张票',
      placeholder: '请选择',
      clearable: false,
      filterable: false,
    },
  ],
  parameters1: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'input-multiple',
      param: 'waybillNos',
      value: '',
      valueType: 'string',
      label: '运单号',
      multiple: true,
      placeholder: '请输入',
      append: '多运单',
      multipleLabel: '运单号',
      multiplePlaceholder:
        '最多可填写50个运单号，需输入完整运单号，运单号中间不能有空格，运单号不换行时请用英文逗号隔开，换行时请每行1个运单号。',
      clearable: true,
    },

    {
      style: 'input-multiple',
      param: 'driverMobiles',
      value: '',
      valueType: 'string',
      label: '司机',
      multiple: true,
      placeholder: '姓名/手机号',
      append: '多司机',
      multipleLabel: '姓名/手机号',
      multiplePlaceholder:
        '最多可填写50个姓名/手机号，需输入完整姓名/手机号，姓名/手机号中间不能有空格，姓名/手机号不换行时请用英文逗号隔开，换行时请每行1个姓名/手机号。',
      clearable: true,
    },
    {
      style: 'input-multiple',
      param: 'vehicleNos',
      value: '',
      valueType: 'string',
      label: '车牌号',
      multiple: true,
      placeholder: '请输入',
      append: '多车牌号',
      multipleLabel: '车牌号',
      multiplePlaceholder:
        '最多可填写50个车牌号，需输入完整车牌号，车牌号中间不能有空格，车牌号不换行时请用英文逗号隔开，换行时请每行1个车牌号。',
      clearable: true,
    },
    {
      style: 'autocomplete',
      param: 'orderName',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'date-picker',
      param: 'insertTime',
      value: [],
      valueType: 'date',
      label: '申请时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['insertStartTime', 'insertEndTime'],
    },
    {
      style: 'select',
      param: 'oneTicket',
      value: 'OFF',
      valueType: 'string',
      state: 'oneTicket',
      label: '是否一张票',
      placeholder: '请选择',
      clearable: false,
      filterable: false,
    },
  ],
  parameters2: [
    {
      style: 'select',
      param: 'corpId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'select',
      param: 'channelCode',
      value: 'noOneTicketCode',
      state: 'oneTicketList',
      valueType: 'string',
      label: '一张票',
      placeholder: '请输入',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getChildLists`,
    },
  ],
  // 特殊筛选项目 带统计信息
  // 按钮筛选项
  isSpecialButton: [
    {
      title: '支付状态',
      name: 'payStatus',
      value: 'PAYING',
      selectList: [
        {
          value: 'PAYING',
          label: '待支付',
          isActive: true,
          count: 0,
        },

        {
          value: 'REFUSE',
          label: '已拒绝',
          isActive: false,
          count: 0,
        },
        {
          value: 'SUCCESS',
          label: '已完成',
          isActive: false,
          count: 0,
        },
      ],
    },
  ],
  isExport: {
    isShow: false,
    method: 'post',
  }, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '支付单号',
        prop: 'id',
        width: 100,
        checked: 1,
        sortable: true,
      },
      {
        label: '申请时间',
        prop: 'applyTime',
        width: 180,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-applyTime',
      },
      {
        label: '运单编号',
        prop: 'waybillNo',
        width: 150,
        checked: 1,
        sortable: true,
      },
      {
        label: '自定义运单号',
        prop: 'upstreamWaybillNo',
        width: 150,
        checked: 1,
        sortable: true,
      },
      {
        label: '线路信息',
        prop: 'sendDistrict',
        width: 130,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-sendDistrict',
      },
      {
        label: '支付方式',
        prop: 'payType',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-payType',
      },
      {
        label: '司机',
        prop: 'driverName',
        width: 100,
        checked: 1,
        sortable: true,
      },
      {
        label: '车辆',
        prop: 'vehicleNo',
        width: 100,
        checked: 1,
        sortable: true,
      },
      {
        label: '支付金额（元）',
        prop: 'settlementAmt',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-settlementAmt',
      },
      {
        label: '支付渠道',
        prop: 'channelName',
        width: 130,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-channelName',
      },
      {
        label: '抵扣税额',
        prop: 'deductionAmt',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-deductionAmt',
      },
      {
        label: '操作',
        width: 100,
        fixed: 'right',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
    countDto: {},
  },
  tableHeadList1: [
    {
      label: '支付单号',
      prop: 'id',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '申请时间',
      prop: 'applyTime',
      width: 180,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-applyTime',
    },
    {
      label: '运单编号',
      prop: 'waybillNo',
      width: 150,
      checked: 1,
      sortable: true,
    },
    {
      label: '自定义运单号',
      prop: 'upstreamWaybillNo',
      width: 150,
      checked: 1,
      sortable: true,
    },
    {
      label: '线路信息',
      prop: 'sendDistrict',
      width: 130,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-sendDistrict',
    },
    {
      label: '支付方式',
      prop: 'payType',
      width: 100,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-payType',
    },
    {
      label: '司机',
      prop: 'driverName',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '车辆',
      prop: 'vehicleNo',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '支付金额（元）',
      prop: 'settlementAmt',
      width: 200,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-settlementAmt',
    },
    {
      label: '支付渠道',
      prop: 'channelName',
      width: 130,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-channelName',
    },
    {
      label: '抵扣税额',
      prop: 'deductionAmt',
      width: 100,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-deductionAmt',
    },
    {
      label: '操作',
      width: 100,
      fixed: 'right',
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-operation',
    },
  ],
  tableHeadList2: [
    {
      label: '支付单号',
      prop: 'settlementId',
      width: 100,
      checked: 1,
      sortable: true,
    },

    {
      label: '运单编号',
      prop: 'waybillNo',
      width: 150,
      checked: 1,
      sortable: true,
    },
    {
      label: '分配时间',
      prop: 'create_time',
      width: 180,
      checked: 1,
      sortable: true,
      slotName: 'sub-domain-createTime',
    },
    {
      label: 'id',
      prop: 'id',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '司机姓名',
      prop: 'driver_name',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '司机类别',
      prop: 'driver_type',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '司机手机号',
      prop: 'driver_account',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '车牌号',
      prop: 'car_no',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '分配场景',
      prop: 'recharge_type',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '分配金额（元）',
      prop: 'money',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '备注',
      prop: 'remark',
      width: 100,
      checked: 1,
      sortable: true,
    },
    {
      label: '领取状态',
      prop: 'status',
      width: 100,
      checked: 1,
      sortable: true,
    },
  ],
  payStatus: [], // 支付状态统计
  companyList: [], // 企业列表
  companyInfo: '', // 当前选中的企业信息
  oneTicket, // 是或者否
  oneTicketList: [],
  routeList: [], //线路列表
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.value === 'string') {
          params[item.param] = item.value.toString();
        } else {
          params[item.param] = item.value;
        }
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    context.state.isSpecialButton.forEach(item => {
      if (item.value) params[item.name] = item.value;
    });
    // 获取统计信息
    context.commit(
      'updateEditTableList',
      params.payStatus === 'SUCCESS' ? context.state.tableHeadList2 : context.state.tableHeadList1,
    );
    var payOilListHabit = {};
    const obj = Object.assign({}, context.state.postParams);
    if (obj.businessId || params.businessId) {
      payOilListHabit.businessId = obj.businessId ? obj.businessId : params.businessId;
    }
    if (obj.orderId) {
      payOilListHabit.routeInfoId = obj.orderId;
    }
    localStorage.setItem('payOilListHabit', JSON.stringify(payOilListHabit));
    if (params.businessId && params.payStatus != 'SUCCESS') {
      context.dispatch('getStatistics');
      const { data } = await pageSettlementByOil(
        Object.assign({}, params, context.state.postParams),
      );
      context.commit('updateState', {
        key: 'listData',
        value: Object.assign({}, context.state.listData, data),
      });
      console.log(data);
      return data.list;
    }
    if (params.corpId && params.payStatus == 'SUCCESS') {
      context.dispatch('getStatistics');
      params.pageSize = context.state.postParams.size;
      params.pageNo = context.state.postParams.page;
      const { data } = await rechargeRecordsByChannel(
        Object.assign({}, params, context.state.postParams),
      );
      context.commit('updateState', {
        key: 'listData',
        value: Object.assign({}, context.state.listData, {
          list: data.data,
          total: Number(data.count),
        }),
      });
      return data.data;
    }
  },
  // 获取状态统计数据
  getStatistics: async context => {
    const { data } = await payStatusByOil({
      businessId: context.state.parameters[0].value,
    });
    context.commit('updateState', {
      key: 'payStatus',
      value: data,
    });
    data.forEach(item => {
      const index = context.state.isSpecialButton[0].selectList.findIndex(selectItem => {
        return selectItem.value === (item.payStatus || item.thirdWithdrawStatus);
      });
      context.commit('updateButtonValueFromIndex', {
        index,
        value: item.count,
      });
    });
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取线路列表
  getRouteList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getRouteListByBid({
        businessId: context.state.parameters[0].value,
        lineType: 'transfer',
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.orderName;
        });
        context.commit('updateState', {
          key: 'routeList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  getChildLists: async (context, keyword) => {
    const { code, data } = await getChildList({
      parentCategoryCode: 'one_ticket',
    });
    if (code === 200) {
      data.forEach(item => {
        item.value = item.categoryCode;
        item.label = item.name;
      });
      context.commit('updateState', {
        key: 'oneTicketList',
        value: data,
      });
    }
  },
};
// mutations
const mutations = {
  // 更新列表表头数据
  updateEditTableList(state, payload) {
    state.listData.tableHeadList = payload;
  },
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        if (item.multiple && item.style !== 'input-multiple') {
          item.value = [];
        } else {
          item.value = '';
        }
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
      if (item.param == 'channelCode') {
        item.value = 'noOneTicketCode';
      }
    });
    console.log(state.parameters, ' state.parameters');
    state.parameters[6].value = 'OFF';
    state.isSpecialButton.forEach(item => {
      item.value = 'PAYING';
      item.selectList.forEach(select => {
        select.isActive = item.value.includes(select.value);
      });
    });
  },
  // 更新筛选
  updateEditParams(state, payload) {
    if (payload == 'SUCCESS') {
      state.parameters = state.parameters2;
    } else {
      state.parameters = state.parameters1;
    }
    state.parameters[0].value = state.companyInfo.businessId;
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        if (payload.from !== 1) {
          localStorage.removeItem('payOilListHabit');
          localStorage.setItem(
            'payOilListHabit',
            JSON.stringify({
              businessId: payload.value,
            }),
          );
        }
        state.postParams.businessId = payload.value;
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        break;
      case 'corpId':
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        break;
      case 'orderName':
        console.log('orderName', payload);
        state.postParams.orderId = payload.id;
        break;
      default:
        break;
    }
  },
  // 根据index&value更新按钮状态
  updateSpecialStatusFromIndex(state, payload) {
    // 要修改的按钮组
    const specialData = state.isSpecialButton[payload.index];
    specialData.value = payload.value;
    specialData.selectList.forEach(item => {
      item.isActive = item.value === payload.value;
    });
  },
  // 更新按钮统计数据
  updateButtonValueFromIndex(state, payload) {
    state.isSpecialButton[0].selectList[payload.index].count = payload.value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
